/* =========================================================================
   NeuroPulse ADV V3 — Script (V3.1 myoro-tier reskin)
   Modules: reveal observer + multi-CTA pulse + number counters + carousel + offer tier
   ========================================================================= */

(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var IOSupported = 'IntersectionObserver' in window;

  /* -------------------------------------------------------------------------
     Reveal observer — fade-in for .reveal-left / .reveal-up / .reveal-zoom
     ------------------------------------------------------------------------- */
  function initRevealObserver() {
    var SELECTOR = '.reveal-left, .reveal-up, .reveal-zoom, .highlight-sweep, .reveal-words';
    if (reduceMotion) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    if (!IOSupported) {
      document.querySelectorAll(SELECTOR).forEach(function (el) {
        el.classList.add('is-revealed');
      });
      return;
    }
    // Toggle on both directions — operator V3.2: reverse on scroll up
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-revealed');
        } else {
          entry.target.classList.remove('is-revealed');
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll(SELECTOR).forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -------------------------------------------------------------------------
     Multi-CTA pulse (E2)
     ------------------------------------------------------------------------- */
  function initMultiCtaPulse() {
    var blocks = document.querySelectorAll('.multi-cta-repeat-block');
    if (!blocks.length || !IOSupported || reduceMotion) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in-view');
          observer.unobserve(e.target);
        }
      });
    }, { threshold: 0.4, rootMargin: '0px 0px -10% 0px' });
    blocks.forEach(function (b) { observer.observe(b); });
  }

  /* -------------------------------------------------------------------------
     Number counters RAF (E1)
     ------------------------------------------------------------------------- */
  function initNumberCounters() {
    var counters = document.querySelectorAll('[data-count-target]');
    if (!counters.length || !IOSupported) return;
    function formatNumber(n, opts) {
      var formatted = n.toLocaleString('en-US', {
        minimumFractionDigits: opts.decimals || 0,
        maximumFractionDigits: opts.decimals || 0
      });
      return (opts.prefix || '') + formatted + (opts.suffix || '');
    }
    function optsFor(el) {
      return {
        decimals: parseInt(el.dataset.countDecimals || '0', 10),
        prefix: el.dataset.countPrefix || '',
        suffix: el.dataset.countSuffix || ''
      };
    }
    function animate(el) {
      var target = parseFloat(el.dataset.countTarget);
      var opts = optsFor(el);
      if (reduceMotion) {
        el.textContent = formatNumber(target, opts);
        return;
      }
      // cancel any in-flight animation for this element
      if (el._countRAF) cancelAnimationFrame(el._countRAF);
      var duration = 1200;
      var start = performance.now();
      function tick(now) {
        var t = Math.min((now - start) / duration, 1);
        var eased = t === 1 ? 1 : 1 - Math.pow(2, -10 * t);
        el.textContent = formatNumber(target * eased, opts);
        if (t < 1) { el._countRAF = requestAnimationFrame(tick); }
        else { el.textContent = formatNumber(target, opts); el._countRAF = null; }
      }
      el._countRAF = requestAnimationFrame(tick);
    }
    function reset(el) {
      if (reduceMotion) return;
      if (el._countRAF) { cancelAnimationFrame(el._countRAF); el._countRAF = null; }
      el.textContent = formatNumber(0, optsFor(el));
    }
    // Toggle: animate up on enter, reset to 0 on leave — re-animates each scroll-in
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animate(e.target); }
        else { reset(e.target); }
      });
    }, { threshold: 0.5 });
    counters.forEach(function (c) { observer.observe(c); });
  }

  /* -------------------------------------------------------------------------
     Testimonials carousel — auto-advance + dots + pause-on-hover + swipe
     ------------------------------------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = root.querySelectorAll('[data-carousel-slide]');
    var dotsContainer = root.querySelector('[data-carousel-dots]');
    var prevBtn = root.querySelector('[data-carousel-prev]');
    var nextBtn = root.querySelector('[data-carousel-next]');
    var autoplayS = parseFloat(root.dataset.autoplay || '0');
    var current = 0;
    var autoplayTimer = null;
    var isPaused = false;

    if (slides.length <= 1) {
      if (prevBtn) prevBtn.style.display = 'none';
      if (nextBtn) nextBtn.style.display = 'none';
      return;
    }

    // Build dots
    if (dotsContainer) {
      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'customer-carousel__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', 'Go to testimonial ' + (i + 1));
        dot.setAttribute('aria-selected', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () { goTo(i); });
        dotsContainer.appendChild(dot);
      });
    }

    function update() {
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dotsContainer) {
        dotsContainer.querySelectorAll('.customer-carousel__dot').forEach(function (d, i) {
          d.setAttribute('aria-selected', i === current ? 'true' : 'false');
        });
      }
    }
    function goTo(i) {
      current = ((i % slides.length) + slides.length) % slides.length;
      update();
      restartAutoplay();
    }
    function next() { goTo(current + 1); }
    function prev() { goTo(current - 1); }
    function startAutoplay() {
      if (!autoplayS || reduceMotion || isPaused) return;
      stopAutoplay();
      autoplayTimer = window.setInterval(next, autoplayS * 1000);
    }
    function stopAutoplay() {
      if (autoplayTimer) { window.clearInterval(autoplayTimer); autoplayTimer = null; }
    }
    function restartAutoplay() { stopAutoplay(); startAutoplay(); }

    if (prevBtn) prevBtn.addEventListener('click', prev);
    if (nextBtn) nextBtn.addEventListener('click', next);

    // Pause on hover (pointer devices) + on focus-within
    root.addEventListener('mouseenter', function () { isPaused = true; stopAutoplay(); });
    root.addEventListener('mouseleave', function () { isPaused = false; startAutoplay(); });
    root.addEventListener('focusin', function () { isPaused = true; stopAutoplay(); });
    root.addEventListener('focusout', function () { isPaused = false; startAutoplay(); });

    // Pause when off-screen
    if (IOSupported) {
      var visObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { isPaused = false; startAutoplay(); }
          else { isPaused = true; stopAutoplay(); }
        });
      }, { threshold: 0.3 });
      visObs.observe(root);
    }

    // Swipe (touch)
    var startX = null;
    track.addEventListener('touchstart', function (e) {
      startX = e.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) { dx < 0 ? next() : prev(); }
      startX = null;
      startAutoplay();
    }, { passive: true });

    // Keyboard
    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
    });

    update();
    startAutoplay();
  }

  /* -------------------------------------------------------------------------
     Offer tier selector (M8)
     ------------------------------------------------------------------------- */
  function initOfferTierSelector() {
    var tiers = document.querySelectorAll('.offer-tier[data-selectable]');
    if (!tiers.length) return;
    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (o) {
          o.classList.toggle('is-selected', o === t);
        });
      });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); t.click(); }
      });
    });
  }

  /* -------------------------------------------------------------------------
     Init all
     ------------------------------------------------------------------------- */
  function init() {
    initRevealObserver();
    initMultiCtaPulse();
    initNumberCounters();
    initOfferTierSelector();
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
